export enum MobileTopGradientAnchor {
  Viewport = 'viewport',
  ParentBottom = 'parent-bottom',
}
